// extracted by mini-css-extract-plugin
export default {"formItemLeft":"FormItemLeft_formItemLeft__-OSum","formTitle":"FormItemLeft_formTitle__hWyYR"};